import React, { useState } from "react";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { Grid, Box } from "@mui/material";
import { StyledWithdrawButton, StyledDivider, ClickableDiv } from "./styled";
import { WithdrawAlert } from "../AgentPages/SearchedAppInfo/components/PreliminaryCriteriaForm/WithdrawAlert";

/**
 * AccordionFooter component for displaying footer actions in the accordion.
 * @param {Object} props
 * @param {boolean} props.expanded - Accordion expanded state
 * @param {Function} props.toggleExpand - Function to toggle accordion expansion
 */
export const AccordionFooter = ({ expanded, toggleExpand }) => {
  const [displayWithdrawAlert, setDisplayWithdrawAlert] = useState(false);

  return (
    <>
      <StyledDivider data-testid="accordion-footer-divider" />
      <Grid container direction="row" justifyContent="space-between" alignItems="center">
        <Grid item sm={11} xs={10}>
          <Box p={1}>
            <StyledWithdrawButton
              data-testid="withdraw-button"
              onClick={() => setDisplayWithdrawAlert(true)}
              type="button"
            >
              Withdraw
            </StyledWithdrawButton>
          </Box>
        </Grid>
        <Grid container justifyContent="center" alignItems="center" item sm={1} xs={2}>
          <ClickableDiv data-testid="expand-less-icon" onClick={toggleExpand}>
            <ExpandLessIcon />
          </ClickableDiv>
        </Grid>
      </Grid>
      <WithdrawAlert
        isOpen={displayWithdrawAlert}
        handleCancel={() => setDisplayWithdrawAlert(false)}
      />
    </>
  );
};
